'use client'

import React from 'react'
import PageHeader from '@/src/components/commons/generics/PageHeader/PageHeader'
import GraphPrevalentMalwares from './GraphPrevalentMalware'
import GraphMalwareCategory from './GraphMalwareCategory'
import styles from './MalwareTrends.module.scss'
import LandingPageContainer from '@/src/components/commons/generics/LandingPageContainer/LandingPageContainer'

const MalwareTrendsClient: React.FC = () => {
  const pageHeading = 'Malware Trends Tracker'
  const pageSubHeading = 'Most prevalent malware observed in the Zscaler cloud'

  return (
    <>
      <LandingPageContainer containerClasses="w-full max-w-[1440px] text-white mb-0 pb-0!">
        {/* Page Header */}
        <PageHeader
          heading={pageHeading}
          subheading={pageSubHeading}
          className="text-left text-white pb-10 mb-[70px]! border-b border-[#3E4752] max-w-[1130px] mx-auto"
        />
        {/* Section 1: Line Graph */}
        <div className={`${styles.chartSection} mb-[60px]`}>
          <GraphPrevalentMalwares />
        </div>

        {/* Section 2: Parliament Graph */}
        <div className={`${styles.chartSection} mb-[60px]`}>
          <GraphMalwareCategory />
        </div>
      </LandingPageContainer>
    </>
  )
}

export default MalwareTrendsClient
